import { useEffect, useRef } from 'react';
import { MobileVerifyDataType, useMobileVerifyContext } from '../context/MobileVerifyContext';
import CustomerHelper from '../helpers/CustomerHelper';

const customerHelper = new CustomerHelper();

export interface MobileVerifyResponseType {
  isSuccess?: boolean;
  isAmbiguous?: boolean;
  isTooManyAttempts?: boolean;
  isBadArgument?: boolean;
  isNoMatch?: boolean;
  isAlreadyVerified?: boolean;
  currentMobileNumber?: string;
  loginMobileVerifySkipped?: boolean;
  accountMobileVerifySkipped?: boolean;
  mongoCustomerId?: string;
  raw?: any;
}

export async function verifyCustomerMobile({
  onSuccess,
  onError,
}: {
  onSuccess: (response: MobileVerifyResponseType) => void;
  onError: (response: MobileVerifyResponseType) => void;
}): Promise<void> {
  try {
    const verifiedResponse = await customerHelper.getCustomerData(window?.Jbhifi?.shopifyCustomerId);
    if (verifiedResponse.isSuccess)
      onSuccess({
        ...verifiedResponse,
        currentMobileNumber: verifiedResponse.raw.data.phone,
        mongoCustomerId: verifiedResponse.raw.data.customerId,
        loginMobileVerifySkipped: Boolean(verifiedResponse.raw.data.preferences?.shopify_login_skipMobileVerification),
        accountMobileVerifySkipped: Boolean(
          verifiedResponse.raw.data.preferences?.shopify_account_skipMobileVerification
        ),
      });
    else onError({ isSuccess: false });
  } catch (error) {
    console.error(error);
    onError({ isSuccess: false });
  }
}

const useMobileVerify = (
  onVerifyMobileResponse?: (response: MobileVerifyResponseType) => void,
  shouldStartVerifying = true
): { data: MobileVerifyDataType; setMobileVerifyData: (data: MobileVerifyDataType) => void } => {
  const { data, setMobileVerifyData } = useMobileVerifyContext();
  const haveInitiallyVerified = useRef<boolean>(false);

  useEffect(() => {
    if (!haveInitiallyVerified.current && shouldStartVerifying) {
      haveInitiallyVerified.current = true;
      setMobileVerifyData({ loading: true, fetchError: false });

      verifyCustomerMobile({
        onSuccess: async (response: MobileVerifyResponseType) => {
          const verifyData = { ...response, loading: false, fetchError: false, refetch: false, mobileNumber: null };
          setMobileVerifyData(verifyData);
          if (onVerifyMobileResponse) {
            onVerifyMobileResponse(verifyData);
          }
        },
        onError: (response: MobileVerifyResponseType) => {
          const verifyData = { ...response, loading: false, fetchError: true };
          setMobileVerifyData(verifyData);
          if (onVerifyMobileResponse) {
            onVerifyMobileResponse(verifyData);
          }
        },
      });
    }
  }, [shouldStartVerifying, haveInitiallyVerified]);

  return { data, setMobileVerifyData };
};

export default useMobileVerify;
